// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1C-12","label":"Section_label__2CMDJ","contentWrap":"Section_contentWrap__3bb0g","footer":"Section_footer__31NCO","footerInner":"Section_footerInner__wgkmc"};